import { Alert, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { DisconnectOutlined } from '@ant-design/icons';
import Flex from '../Flex';

export interface RetryAlertProps {
  noIcon?: boolean;
  action?: () => void;
  actionText?: string;
  content?: React.ReactElement | string;
}

export default function RetryAlert({
  noIcon = false,
  action = undefined,
  actionText = undefined,
  content = undefined,
}: RetryAlertProps) {

  const [t] = useTranslation(['common']);

  if (!actionText) {
    actionText = t('common:labels.try-again');
  }

  if (!content) {
    content = t('common:errors.connection-error');
  }

  return (
    <Flex
      inlineFlex
      align="center"
      direction="column"
      style={{ maxWidth: 'min(95vw, 400px)' }}
      className="w-full mx-auto">
      <Alert
        className="w-full mx-2"
        type="error"
        message={(
          <Flex className="w-full p-4" direction="column">
            {!noIcon && <DisconnectOutlined className="text-red-700 text-3xl my-4" />}
            <b className="text-red-700 mx-auto">{content}</b>
            {action &&
              <Flex className="mt-3" inlineFlex>
                <Button size="middle" onClick={action} className="mx-auto" type="default">
                  {actionText}
                </Button>
              </Flex>
            }
          </Flex>
        )}
      />
    </Flex>
  );
}
